import { render, staticRenderFns } from "./AccessoriesPage.vue?vue&type=template&id=9b8c8496&scoped=true"
import script from "./AccessoriesPage.vue?vue&type=script&lang=js"
export * from "./AccessoriesPage.vue?vue&type=script&lang=js"
import style0 from "./AccessoriesPage.vue?vue&type=style&index=0&id=9b8c8496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c8496",
  null
  
)

export default component.exports